module.exports = __webpack_public_path__ + "img/logo-kebab-brothers.16f8fbab.png";